import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Button,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
  Badge,
} from 'reactstrap';
import ArrowUpIcon from 'mdi-react/ArrowUpIcon';
import ArrowDownIcon from 'mdi-react/ArrowDownIcon';
import moment from 'moment';
import Loading from '../../shared/components/custom/Loading';
import useModal from '../../shared/hooks/useModal';
import Api from '../../util/api';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import Pagination from '../../shared/components/pagination/Pagination';
import t, { partial } from '../../util/translation/translation';
import { formatDateTime, formatDate } from '../../util/date-and-time';

const QuestionaireCategoryListPage = ({ setLoading }) => {
  const [questionaireCategories, setQuestionaireCategories] = useState([]);
  const [handleModal, visible, deleteID] = useModal();
  const p = partial('questionaire');
  const s = partial('shared');

  const fetchQuestionaireCategories = async () => {
    setLoading(true);
    try {
      const reqQuestionaireCategories =
        await Api.questionaire.categories.getQuestionaireCategories();
      setQuestionaireCategories(reqQuestionaireCategories);
      setLoading(false);
    } catch (err) {
      toast.error(
        p('questionaireCategories.failedToFetchQuestionaireCategories')
      );
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchQuestionaireCategories();
  }, []);
  const deleteQuestionaireCategory = async () => {
    setLoading(true);
    try {
      await Api.questionaire.categories.deleteQuestionaireCategory(deleteID);
      toast.success(p('questionaireCategories.questionaireCategoryDeleted'));
    } catch (err) {
      toast.error(p('questionaireCategories.questionaireCategoryDeleteError'));
    } finally {
      handleModal();
      fetchQuestionaireCategories();
    }
  };

  const renderQuestionaireCategories = () => {
    return questionaireCategories.map((questionaireCategory, i) => {
      return (
        <tr
          style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
          key={`questionaire-category-${questionaireCategory.id}`}
        >
          <td>
            <div className="flex-Vcenter">
              <Link
                to={`/questionaire-category/edit/${questionaireCategory.id}`}
              >
                {questionaireCategory.title}
              </Link>
            </div>
          </td>
          <td>
            {' '}
            <div
              style={{ fontSize: 16, padding: '0 10px 0 10px' }}
              dangerouslySetInnerHTML={{
                __html: questionaireCategory.description,
              }}
            />
          </td>
          <td>{questionaireCategory.questionaires.length}</td>
          <td>
            <UncontrolledDropdown className="dashboard__table-more">
              <DropdownToggle>
                <DotsHorizontalIcon />
              </DropdownToggle>
              <DropdownMenu className="dropdown__menu">
                <Link
                  to={`/questionaire-category/edit/${questionaireCategory.id}`}
                >
                  <DropdownItem>{s('edit')}</DropdownItem>
                </Link>
                <DropdownItem
                  onClick={() => handleModal(questionaireCategory.id)}
                  className="danger"
                >
                  {s('delete')}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <DeleteModal
        visible={visible}
        type={p('theQuestionaire')}
        handleModal={handleModal}
        modalAction={deleteQuestionaireCategory}
      />
      <Row>
        <Col>
          <div className="float-right marginTop-0">
            <Link to="/questionaire-category/create">
              <Button size="sm" color="primary">
                {p('questionaireCategories.createQuestionaireCategory')}
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div
            style={{
              display: 'flex',
              paddingBottom: 5,
              background: '#fff',
              borderRadius: 6,
              boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
            }}
          >
            <Table responsive striped>
              <thead>
                <tr>
                  <th style={{ color: '#4D576A' }} className="sortable">
                    <div className="flex alignItems-center">{s('title')}</div>
                  </th>
                  <th style={{ color: '#4D576A' }} className="sortable">
                    <div className="flex alignItems-center">
                      {s('description')}
                    </div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">
                      {p('questionaires')}
                    </div>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>{renderQuestionaireCategories()}</tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default QuestionaireCategoryListPage;
